import type { EventKey } from "../../../event/server/supabase-event-service";

export const isScheduled = (event: EventKey | null): boolean => {
  return !event || event.has_schedule_event || !event.calendar;
};
